import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';
import { Nullable } from '~globals/types';
import { IntegrationProvidersTypes } from '~globals/types/enums';

import { DialogAddIntegrationRenovateData } from './types';

export const isTiendaNubeIntegration = (
  integrationType: IntegrationProvidersTypes,
): boolean => integrationType === IntegrationProvidersTypes.TiendaNube;

export const isWooComerceIntegration = (
  integrationType: IntegrationProvidersTypes,
): boolean => integrationType === IntegrationProvidersTypes.WooCommerce;

export const isShopifyIntegration = (
  integrationType: IntegrationProvidersTypes,
): boolean => integrationType === IntegrationProvidersTypes.Shopify;

export const FIELDS_NAME = {
  CARRIER_NAME: 'carrierName',
  DESCRIPTION: 'description',
  URL: 'url',
  EMAIL: 'email',
} as const;

export const getDefaultUrlIntegration = (
  integrationType: IntegrationProvidersTypes,
  storeId: Nullable<string>,
): string => {
  let url = '';

  if (
    isWooComerceIntegration(integrationType) ||
    isShopifyIntegration(integrationType)
  ) {
    url = storeId ?? '';
  }

  return url;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (
  integrationType: IntegrationProvidersTypes,
  renovateData?: DialogAddIntegrationRenovateData,
) => ({
  [FIELDS_NAME.CARRIER_NAME]: renovateData?.carrierName ?? '',
  [FIELDS_NAME.DESCRIPTION]: renovateData?.description ?? '',
  [FIELDS_NAME.URL]: getDefaultUrlIntegration(
    integrationType,
    renovateData?.storeId ?? null,
  ),
  [FIELDS_NAME.EMAIL]: '',
});

const validateUrl = (integrationType: IntegrationProvidersTypes) => {
  if (isWooComerceIntegration(integrationType)) {
    return Yup.string()
      .url(VALIDATIONS_ERROR.URL)
      .required(VALIDATIONS_ERROR.REQUIRED);
  }

  if (isShopifyIntegration(integrationType)) {
    return Yup.string().required(VALIDATIONS_ERROR.REQUIRED);
  }

  return Yup.string().notRequired();
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getValidationSchema = (
  integrationType: IntegrationProvidersTypes,
) =>
  Yup.object().shape({
    [FIELDS_NAME.CARRIER_NAME]: Yup.string().notRequired(),
    [FIELDS_NAME.DESCRIPTION]: isWooComerceIntegration(integrationType)
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.URL]: validateUrl(integrationType),
  });

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const validateEmail = (email: string) => {
  const schema = Yup.string()
    .email(VALIDATIONS_ERROR.EMAIL)
    .required(VALIDATIONS_ERROR.REQUIRED);

  const promise = schema.validate(email, { abortEarly: false });

  return new Promise((resolve, reject) => {
    promise.then(
      () => {
        resolve('');
      },
      (err) => {
        if (err.name === 'ValidationError') {
          resolve(err.message);
        } else {
          reject(err);
        }
      },
    );
  });
};
